/**
 * Popular ISO 4217 currencies for subscription pricing.
 * Order: widely used first, then alphabetical by code.
 */
export const CURRENCIES: ReadonlyArray<{ code: string; name: string }> = [
  { code: "USD", name: "US Dollar" },
  { code: "EUR", name: "Euro" },
  { code: "GBP", name: "British Pound" },
  { code: "JPY", name: "Japanese Yen" },
  { code: "CHF", name: "Swiss Franc" },
  { code: "AUD", name: "Australian Dollar" },
  { code: "CAD", name: "Canadian Dollar" },
  { code: "CNY", name: "Chinese Yuan" },
  { code: "HKD", name: "Hong Kong Dollar" },
  { code: "SGD", name: "Singapore Dollar" },
  { code: "NZD", name: "New Zealand Dollar" },
  { code: "SEK", name: "Swedish Krona" },
  { code: "NOK", name: "Norwegian Krone" },
  { code: "DKK", name: "Danish Krone" },
  { code: "PLN", name: "Polish Zloty" },
  { code: "CZK", name: "Czech Koruna" },
  { code: "HUF", name: "Hungarian Forint" },
  { code: "RON", name: "Romanian Leu" },
  { code: "BGN", name: "Bulgarian Lev" },
  { code: "ISK", name: "Icelandic Króna" },
  { code: "TRY", name: "Turkish Lira" },
  { code: "RUB", name: "Russian Ruble" },
  { code: "UAH", name: "Ukrainian Hryvnia" },
  { code: "MXN", name: "Mexican Peso" },
  { code: "BRL", name: "Brazilian Real" },
  { code: "ARS", name: "Argentine Peso" },
  { code: "CLP", name: "Chilean Peso" },
  { code: "COP", name: "Colombian Peso" },
  { code: "PEN", name: "Peruvian Sol" },
  { code: "UYU", name: "Uruguayan Peso" },
  { code: "INR", name: "Indian Rupee" },
  { code: "PKR", name: "Pakistani Rupee" },
  { code: "BDT", name: "Bangladeshi Taka" },
  { code: "LKR", name: "Sri Lankan Rupee" },
  { code: "NPR", name: "Nepalese Rupee" },
  { code: "KRW", name: "South Korean Won" },
  { code: "THB", name: "Thai Baht" },
  { code: "MYR", name: "Malaysian Ringgit" },
  { code: "PHP", name: "Philippine Peso" },
  { code: "IDR", name: "Indonesian Rupiah" },
  { code: "VND", name: "Vietnamese Dong" },
  { code: "TWD", name: "New Taiwan Dollar" },
  { code: "AED", name: "UAE Dirham" },
  { code: "SAR", name: "Saudi Riyal" },
  { code: "QAR", name: "Qatari Riyal" },
  { code: "KWD", name: "Kuwaiti Dinar" },
  { code: "BHD", name: "Bahraini Dinar" },
  { code: "OMR", name: "Omani Rial" },
  { code: "JOD", name: "Jordanian Dinar" },
  { code: "ILS", name: "Israeli Shekel" },
  { code: "IRR", name: "Iranian Rial" },
  { code: "EGP", name: "Egyptian Pound" },
  { code: "ZAR", name: "South African Rand" },
  { code: "NGN", name: "Nigerian Naira" },
  { code: "KES", name: "Kenyan Shilling" },
  { code: "GHS", name: "Ghanaian Cedi" },
  { code: "MAD", name: "Moroccan Dirham" },
  { code: "TND", name: "Tunisian Dinar" },
  { code: "BWP", name: "Botswana Pula" },
  { code: "XAF", name: "CFA Franc (BEAC)" },
  { code: "XOF", name: "CFA Franc (BCEAO)" },
  { code: "HRK", name: "Croatian Kuna" },
  { code: "RSD", name: "Serbian Dinar" },
  { code: "BAM", name: "Bosnia Mark" },
  { code: "MKD", name: "Macedonian Denar" },
  { code: "ALL", name: "Albanian Lek" },
  { code: "GEL", name: "Georgian Lari" },
  { code: "AMD", name: "Armenian Dram" },
  { code: "AZN", name: "Azerbaijani Manat" },
  { code: "KZT", name: "Kazakhstani Tenge" },
  { code: "UZS", name: "Uzbekistani Som" },
  { code: "KGS", name: "Kyrgyzstani Som" },
  { code: "MNT", name: "Mongolian Tugrik" },
  { code: "FJD", name: "Fijian Dollar" },
  { code: "PGK", name: "Papua New Guinean Kina" },
  { code: "CRC", name: "Costa Rican Colón" },
  { code: "GTQ", name: "Guatemalan Quetzal" },
  { code: "HNL", name: "Honduran Lempira" },
  { code: "NIO", name: "Nicaraguan Córdoba" },
  { code: "PAB", name: "Panamanian Balboa" },
  { code: "DOP", name: "Dominican Peso" },
  { code: "JMD", name: "Jamaican Dollar" },
  { code: "BBD", name: "Barbadian Dollar" },
  { code: "BSD", name: "Bahamian Dollar" },
  { code: "BZD", name: "Belize Dollar" },
  { code: "TTD", name: "Trinidad Dollar" },
  { code: "BOB", name: "Bolivian Boliviano" },
  { code: "PYG", name: "Paraguayan Guaraní" },
  { code: "VES", name: "Venezuelan Bolívar" },
  { code: "CUP", name: "Cuban Peso" },
  { code: "ANG", name: "Netherlands Antillean Guilder" },
  { code: "AWG", name: "Aruban Florin" },
  { code: "XCD", name: "East Caribbean Dollar" },
  { code: "BMD", name: "Bermudian Dollar" },
  { code: "KYD", name: "Cayman Islands Dollar" },
  { code: "MOP", name: "Macanese Pataca" },
  { code: "BND", name: "Brunei Dollar" },
  { code: "KHR", name: "Cambodian Riel" },
  { code: "LAK", name: "Lao Kip" },
  { code: "MMK", name: "Myanmar Kyat" },
  { code: "AFN", name: "Afghan Afghani" },
  { code: "IQD", name: "Iraqi Dinar" },
  { code: "LBP", name: "Lebanese Pound" },
  { code: "SYP", name: "Syrian Pound" },
  { code: "YER", name: "Yemeni Rial" },
  { code: "MVR", name: "Maldivian Rufiyaa" },
  { code: "NAD", name: "Namibian Dollar" },
  { code: "SZL", name: "Swazi Lilangeni" },
  { code: "LSL", name: "Lesotho Loti" },
  { code: "MZN", name: "Mozambican Metical" },
  { code: "UGX", name: "Ugandan Shilling" },
  { code: "TZS", name: "Tanzanian Shilling" },
  { code: "RWF", name: "Rwandan Franc" },
  { code: "ETB", name: "Ethiopian Birr" },
  { code: "ZMW", name: "Zambian Kwacha" },
  { code: "MWK", name: "Malawian Kwacha" },
  { code: "MGA", name: "Malagasy Ariary" },
  { code: "MUR", name: "Mauritian Rupee" },
  { code: "SCR", name: "Seychellois Rupee" },
];

export const CURRENCY_CODES = new Set(CURRENCIES.map((c) => c.code));
